import React, { useState, useImperativeHandle, forwardRef } from 'react'
import { Button } from '@material-ui/core'
import { useAuthDataContext } from '../../../../__providers/AuthProvider'
import Api from '../../../../__helpers/api'

//actions
import { refreshNotification } from '../../../../__actions/notifications'
import { handleModal } from '../../../../__actions/globalModals'

//dispatcher
import { useDispatch, useSelector } from 'react-redux'

//images
import mainIcon from '../../../../assets/images/modals/messages/just-registered/icons/main.png'

function JustRegistered(props, ref) {
    const auth = useAuthDataContext()
    const dispatch = useDispatch()

    //
    const __data = useSelector(state => state)
    //
    const data = __data?.globalModalsReducer?.JUST_REGISTERED?.data || {}

    const [state, setState] = useState({
        blur: false,
        popup: false,
    })

    useImperativeHandle(ref, () => ({
        open: () => handleOpen(),
        close: () => handleClose()
    }))

    const handleOpen = () => {
        document.querySelector('body').style.overflow = 'hidden'
        document.querySelector('html').style.overflow = 'hidden'

        setState(state => ({
            ...state,
            blur: true,
        }))
        setTimeout(() => {
            setState(state => ({
                ...state,
                popup: true
            }))
        }, 50)
    }

    const handleClose = () => {
        dispatch(handleModal('JUST_REGISTERED', false, {}))

        document.querySelector('body').style.overflow = 'initial'
        document.querySelector('html').style.overflow = 'initial'

        Api.post('notifications/mark-as-read', {
            id: data?.id
        })
            .then(() => {
                dispatch(refreshNotification())
            })

        setState(state => ({
            ...state,
            popup: false
        }))
        setTimeout(() => {
            setState(state => ({
                ...state,
                blur: false,
            }))
        }, 100)
    }

    return (
        <div id="overlay" className={`scrollable-mobile ${state.blur ? 'visible' : ''}`}>
            <div className={`box just-registered-modal ${state.popup ? 'show' : ''}`}>
                <img src={mainIcon} className="main" />
                <h2>
                    Привет, {data?.name},
                </h2>
                <h4>
                    радваме се, че се присъедини към общността на Авто Обучение!
                    <br />
                    Мисията ни е да създаваме по-подготвени и уверени шофьори на пътя.
                 </h4>
                <p>
                    <b>Авто Обучение ти гарантира</b> успешното вземане на официалния изпит по теория с лекота, като те води <b>последователно</b> през всички 19 теми.
                 </p>
                <ul className="list">
                    <li>
                        <span>
                            1
                        </span>
                        <p>
                            Първо гледай видео лекциите в Авто Обучение, защото те ти помагат да постигнеш <b>максимален резултат;</b>
                        </p>
                    </li>
                    <li>
                        <span>
                            2
                        </span>
                        <p>
                            След това решавай изпитните въпроси след всяка тема, за да затвърдиш <b>знанията си;</b>
                        </p>
                    </li>
                    <li>
                        <span>
                            3
                        </span>
                        <p>
                            Слушай за всеки въпрос разяснение от актуалния Закон за Движението по Пътищата,
                            <br />
                            за да си <b>по-подготвен шофьор.</b>
                        </p>
                    </li>
                </ul>
                <ul className="included">
                    <li>
                        Всички учебни материали в Авто Обучение са изготвени съобразно официалната учебната програма утвърдена от МОН и ИА „Автомобилна Администрация“.
                    </li>
                    {/* <li>
                        {auth?.user?.center?.id ?
                            `Твоят преподавател от учебен център ${auth.user.center.name} лесно може да следи твоето развитие и да ти помага.` :
                            `След като посочиш своята автошкола, инструкторът ти ще може да следи твоето развитие и да ти помага.`}
                    </li> */}
                </ul>
                <p>
                    Подготви се с Авто Обучение сигурно и лесно за изпита по теория и бъди уверен на пътя.
                </p>
                <br />
                <p>
                    <b>
                        Поздрави,
                        <br />
                        Сияна Иванова!
                   </b>
                </p>
                <br />
                <Button onClick={handleClose}>
                    Супер!
                </Button>
            </div>
        </div >
    )
}

export default forwardRef(JustRegistered)